export * from './lib/table.module';
export * from './lib/model/config';
export * from './lib/model/columns';
export * from './lib/model/event.enum';
export * from './lib/model/pagination';
export * from './lib/model/api';
export { DefaultConfig } from './lib/services/config-service';

export * from './lib/components/base/base.component';
export * from './lib/components/header/header.component';
